module.exports = __webpack_public_path__ + "static/media/44_A.094029fe.png";